import React from 'react';
import { get } from 'lodash';
import PropTypes from 'prop-types';

function FireSafetyInformation({ data }) {
  return (
    <div className="p-3">
      <table className="transaction-table table table-borderless table-sm mb-1">
        <tbody>
          <tr className="d-flex">
            <td width="350">
              <span className="title" style={{ fontSize: '16px' }}>
                FIRE SAFETY DETAILS
              </span>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="250">
              FSIC Number
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'attributes.fsic_number') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="250">
              FSIS Reference Number
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'attributes.fsis_reference_number') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="250">
              FSIS Status
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'attributes.fsis_status') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="250">
              Validity Date
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'attributes.validity_date_human') || '-'}</b>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

FireSafetyInformation.propTypes = {
  data: PropTypes.instanceOf(Object),
};

FireSafetyInformation.defaultProps = {
  data: {},
};

export default FireSafetyInformation;
